export default __webpack_public_path__ + "static/media/07-fosbury.6fa1f90e.jpg";